import { LAYER_TOGGLES } from "../map/layers/toggles";
import { COPY } from "../content/copy";
import type { LayerName } from "../map/layers/types";
import "../styles/legend.css";
import "../styles/layer-toggle-panel.css";

type Props = {
  activeLayer: LayerName | null;
  onToggle: (name: LayerName | null) => void;
};

export function LayerTogglePanel({ activeLayer, onToggle }: Props) {
  return (
    <aside className="panel layer-toggle-panel" aria-label="layer toggles">
      {LAYER_TOGGLES.map((group) => (
        <div key={group.group} className="layer-group">
          <div className="layer-group-title mono">{group.label}</div>
          <ul className="layer-toggle-list">
            {group.layers.map((name) => {
              const isActive = activeLayer === name;
              const block = (COPY.layers as any)[name];
              return (
                <li key={name}>
                  <button
                    type="button"
                    className={`chip chip-tag ${isActive ? "chip-status" : ""}`}
                    aria-pressed={isActive}
                    onClick={() => onToggle(isActive ? null : name)}
                  >
                    {block.title.text}
                  </button>
                </li>
              );
            })}
          </ul>
        </div>
      ))}
    </aside>
  );
}
